// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"tag-module--tagContainer--3Uf9c"};